import { capfirst, intcomma } from 'journalize';
import cx from 'classnames';
import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';

// internal
import {
  sort_candidates_by_party,
  get_directory_slug,
} from '../election-utils';
import sumValues from '../utils/sum-values';

// text
import text from '../../../data/text.json';

const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  tableHeader: JSX.Element;
  contestTitle: string;
  contestOffice: string;
  renderCandidate: any;
  visibleCandidatesCount?: number;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      contestOffice,
      renderCandidate,
      tableHeader,
    } = this.props;

    let totalVotes;

    const isStatewide = contest.division_type === 'statewide';


    // The Republic API slugs don't match the directory url slugs so we need to get them

    let directory_slug;


    if (contest) {
      directory_slug = get_directory_slug(contest.office);
    }

   let candidates = contest.candidacies;

    let partyName = contest.party;

    const rowClass = cx('seat__race', {
        'seat__race--Democrat': partyName == 'Democrat',
        'seat__race--Republican': partyName == 'Republican',
      });


    return (
      <div class="seat">

          <div class={rowClass}>
        <div class="race">
          <h4 class="race__title">

          {contestOffice != null && (
                <h2 class="office__title">
                {contestOffice}
                </h2>
              )}

         
            
     
          {contestTitle}
            {directory_slug[0] != null && (
                <a
                  href={`https://www.texastribune.org/directory/districts/${directory_slug[0]['directory-slug']}/${contest['office_division']}`}
                >
                  <span
                    class="icon-div"
                    title="Click to learn more about this district"
                  >
                    <svg class="icon icon-info">
                      <use xlinkHref="#icon-info"></use>
                    </svg>
                  </span>
                </a>
              )}
            {contest.office != 'U.S. Senate' && contest.office != 'Texas Railroad Commission' && (
              <span class='dash'>
                -
              </span>
            )}
            {partyName == 'Democrat' && (
              <span>
                 {partyName}ic
              </span>
            )}
            {partyName == 'Republican' && (
              <span>
                {partyName}
              </span>
            )}
          </h4>

          <table class="race__candidates">
            {tableHeader}
            <tbody>
              {candidates.map((candidate: any, idx: any) =>
                renderCandidate(candidate, idx, {
                  totalVotes,
                })
              )}
            </tbody>
          </table>
        </div>
      </div>


      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  visibleCandidatesCount: 3,
};

export default Contest;
